import { CardBackgroundColor } from '@api/selections';
import { Box, BoxProps, styled } from '@mui/material';
import { colors } from '@themes/colors';
import { palette } from '@themes/theme.helpers';
import classnames from 'classnames';
import { ReactNode } from 'react';

const Background = styled(Box)`
  background: ${palette.background('paper')};
  color: ${palette.text('primary')} !important;
  border-radius: 4px;
  &.white {
    background: ${palette.background('paper')};
  }
  &.transparent {
    background: #e6ecedaa;
  }
  &.green {
    background: ${palette.primary('main')};
  }
  &.green-dark {
    background: ${palette.primary('dark')};
  }
  &.green-light {
    background: ${palette.primary('light')};
  }
  &.blue-light {
    background: ${colors.secondary.lightBlue};
  }
  &.blue-medium {
    background: ${colors.secondary.mediumBlue};
  }
  &.black {
    background: ${palette.common('black')};
    color: ${palette.common('white')};
  }
`;

export type BackgroundCardProps = BoxProps & {
  children?: ReactNode;
  background?: CardBackgroundColor;
};

export const BackgroundCard = ({
  background,
  children,
  className,
  ...props
}: BackgroundCardProps) => {
  const mainClassName = classnames('background-card', className, background);
  return (
    <Background className={mainClassName} {...props}>
      {children}
    </Background>
  );
};
